import { ApiUrl } from "../../ApiUrl";

export const fetchLoggedInTeacherOption = async () => {
  const orgId = localStorage.getItem("orgId") || "";
  const branchId = localStorage.getItem("branchId") || "";
  const teacherId = sessionStorage.getItem("userId") || "";

  if (!orgId || !branchId || !teacherId) {
    return null;
  }

  const response = await fetch(
    `${ApiUrl.apiurl}Teacher/GetEmployeeList/?orgId=${orgId}&branchId=${branchId}&employeeId=${teacherId}`
  );
  const data = await response.json();

  if (
    data?.message === "success" &&
    Array.isArray(data.data) &&
    data.data.length > 0
  ) {
    const teacher = data.data[0];
    return {
      value: teacher.id,
      label: teacher.employeeName,
    };
  }

  return null;
};
